$(function () {
	$('.partials-header-default').each(function () {
		const $wrap = $(this);
		const $kids = $wrap.children(); 

		if ($kids.length === 1 && $kids.eq(0).is('.h-part')) {
		  $wrap.addClass('single-child');
		} else {
		  $wrap.removeClass('single-child'); 
		}
	});
});

